import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import trackServiceInquiry from '../utils/trackServiceInquiry';

const css = `
  .contact-root{
    --blue: #0072F5;
    --blue-dark: #0052B3;
    --ink: #0B0D10;
    --paper: #F6F4EF;
    --paper-dim: #ECE8DF;
    --line: rgba(11,13,16,0.12);
    background:var(--paper);
    color:var(--ink);
    font-family:'Inter',sans-serif;
    -webkit-font-smoothing:antialiased;
  }
  .contact-root *{box-sizing:border-box;}
  .contact-root .serif{font-family:'Newsreader', serif; font-weight:400;}
  .contact-root .wrap{max-width:1240px; margin:0 auto; padding:0 32px;}
  .contact-root a{color:inherit; text-decoration:none;}

  .contact-root header{
    position:fixed; top:0; left:0; right:0; z-index:90;
    background:rgba(246,244,239,0.92); backdrop-filter:blur(10px);
    border-bottom:1px solid var(--line);
  }
  .contact-root nav{
    display:flex; align-items:center; justify-content:space-between;
    padding:20px 32px; max-width:1240px; margin:0 auto;
  }
  .contact-root .logo{font-weight:800; font-size:18px; letter-spacing:-0.02em;}
  .contact-root .logo span{color:var(--blue);}
  .contact-root .nav-links{display:flex; gap:36px; font-size:14px; font-weight:500;}
  .contact-root .nav-links a{opacity:.7; transition:opacity .2s;}
  .contact-root .nav-links a:hover{opacity:1;}
  .contact-root .nav-actions{display:flex; align-items:center; gap:22px;}
  .contact-root .nav-login{font-size:14px; font-weight:600; opacity:.75; transition:opacity .2s;}
  .contact-root .nav-login:hover{opacity:1;}
  .contact-root .nav-cta{
    font-size:14px; font-weight:600; padding:10px 20px;
    border:1px solid var(--ink); border-radius:2px;
    transition:background .2s, color .2s;
  }
  .contact-root .nav-cta:hover{background:var(--ink); color:var(--paper);}
  .contact-root .nav-toggle{display:none; background:none; border:none; cursor:pointer; padding:8px; margin-left:8px;}
  .contact-root .nav-toggle span{display:block; width:20px; height:2px; background:var(--ink); margin:4px 0;}

  .contact-root .hero{padding:160px 0 64px; border-bottom:1px solid var(--line); text-align:center;}
  .contact-root .eyebrow{
    font-size:13px; font-weight:600; letter-spacing:.12em; text-transform:uppercase;
    color:var(--blue-dark); margin-bottom:20px; display:flex; align-items:center; justify-content:center; gap:10px;
  }
  .contact-root .eyebrow::before{content:''; width:7px; height:7px; background:var(--blue); border-radius:50%; display:inline-block;}
  .contact-root .hero h1{
    font-size:clamp(36px, 5vw, 58px); line-height:1.05; letter-spacing:-0.02em; font-weight:800; margin:0 auto 20px;
    max-width:720px;
  }
  .contact-root .hero h1 em{font-style:normal; color:var(--blue);}
  .contact-root .hero p{font-size:18px; line-height:1.55; color:#3a3d42; max-width:560px; margin:0 auto;}

  .contact-root .section{padding:90px 0; border-bottom:1px solid var(--line);}
  .contact-root .contact-grid{display:grid; grid-template-columns:0.85fr 1.15fr; gap:64px;}

  .contact-root .info-label{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:24px;}
  .contact-root .info-list{display:flex; flex-direction:column;}
  .contact-root .info-row{display:flex; gap:18px; padding:24px 0; border-top:1px solid var(--line);}
  .contact-root .info-row:first-child{border-top:none;}
  .contact-root .info-row .num{font-family:'Newsreader', serif; font-size:22px; color:var(--blue); flex-shrink:0; width:32px;}
  .contact-root .info-row h3{font-size:16px; font-weight:700; margin:0 0 4px; letter-spacing:-0.01em;}
  .contact-root .info-row p{font-size:14.5px; color:#52555a; line-height:1.55; margin:0;}
  .contact-root .info-row a{color:var(--blue-dark); font-weight:600;}
  .contact-root .info-row a:hover{text-decoration:underline;}

  .contact-root .form-card{border:1px solid var(--line); border-radius:8px; padding:40px; background:#fff;}
  .contact-root .form-card h2{font-size:23px; font-weight:700; letter-spacing:-0.01em; margin:0 0 28px;}
  .contact-root .field{margin-bottom:22px;}
  .contact-root .field label{display:block; font-size:13px; font-weight:600; color:#52555a; margin-bottom:8px;}
  .contact-root .field input,
  .contact-root .field textarea{
    width:100%; font-family:'Inter',sans-serif; font-size:15px; padding:12px 14px;
    border:1px solid var(--line); border-radius:4px; background:var(--paper);
    color:var(--ink); transition:border-color .2s;
  }
  .contact-root .field input:focus,
  .contact-root .field textarea:focus{outline:none; border-color:var(--blue);}
  .contact-root .submit-btn{
    width:100%; background:var(--ink); color:var(--paper); padding:15px 26px;
    font-weight:600; font-size:15px; border-radius:2px; border:none; cursor:pointer;
    transition:background .2s, opacity .2s; display:flex; align-items:center; justify-content:center; gap:8px;
  }
  .contact-root .submit-btn:hover:not(:disabled){background:var(--blue-dark);}
  .contact-root .submit-btn:disabled{opacity:.5; cursor:not-allowed;}

  .contact-root .success-card{
    border:1px solid var(--line); border-radius:8px; padding:48px 40px;
    background:#fff; text-align:center;
  }
  .contact-root .success-icon{
    width:56px; height:56px; border-radius:50%; background:var(--blue);
    display:flex; align-items:center; justify-content:center; margin:0 auto 24px;
    color:#fff; font-size:26px; line-height:1;
  }
  .contact-root .success-card h2{font-size:22px; font-weight:800; letter-spacing:-0.01em; margin:0 0 12px;}
  .contact-root .success-card p{font-size:15px; color:#52555a; line-height:1.6; margin:0;}

  .contact-root .faq-section .section-head{text-align:center; margin-bottom:64px;}
  .contact-root .faq-section .section-num{font-size:13px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:16px;}
  .contact-root .faq-section h2{font-size:clamp(28px,4vw,40px); font-weight:800; letter-spacing:-0.01em; margin:0 0 14px;}
  .contact-root .faq-section .sub{font-size:16px; color:#52555a; margin:0;}
  .contact-root .faq-list{max-width:760px; margin:0 auto;}
  .contact-root .faq-item{padding:32px 0; border-top:1px solid var(--line);}
  .contact-root .faq-item:last-child{border-bottom:1px solid var(--line);}
  .contact-root .faq-item h3{font-size:18px; font-weight:700; margin:0 0 10px; letter-spacing:-0.01em;}
  .contact-root .faq-item p{font-size:15px; color:#52555a; line-height:1.6; margin:0;}

  .contact-root footer{padding:64px 0 32px; border-top:1px solid var(--line);}
  .contact-root .foot-cols{display:grid; grid-template-columns:1.6fr 1fr 1fr 1fr; gap:40px; padding-bottom:48px; border-bottom:1px solid var(--line); margin-bottom:24px;}
  .contact-root .foot-brand p{font-size:14px; color:#6b6e73; margin-top:14px; max-width:260px; line-height:1.55;}
  .contact-root .foot-col-title{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:16px;}
  .contact-root .foot-col a{display:block; font-size:14px; color:#52555a; padding:6px 0; transition:color .2s;}
  .contact-root .foot-col a:hover{color:var(--ink);}
  .contact-root .foot-bottom{font-size:13px; color:#6b6e73;}

  @media (max-width:860px){
    .contact-root .hero{padding-top:188px;}
    .contact-root .contact-grid{grid-template-columns:1fr; gap:48px;}
    .contact-root .form-card{padding:28px;}
    .contact-root .foot-cols{grid-template-columns:1fr; gap:32px;}

    .contact-root nav{flex-wrap:wrap; row-gap:14px;}
    .contact-root .nav-toggle{display:flex; flex-direction:column; justify-content:center; gap:5px; order:2; margin-left:auto;}
    .contact-root .nav-actions{order:3;}
    .contact-root .nav-links{
      display:none; order:4; width:100%; flex-direction:column; gap:0;
      border-top:1px solid var(--line); padding-top:8px;
    }
    .contact-root .nav-links.open{display:flex;}
    .contact-root .nav-links a{padding:14px 0; border-bottom:1px solid var(--line); opacity:1;}
  }
`;

const faqs = [
  {
    question: 'What does DataBackfill do?',
    answer:
      'DataBackfill is a boutique AI & data delivery studio. We build production AI agents, RAG and knowledge systems, Claude integrations, and data infrastructure, including GA4-to-BigQuery pipelines, for companies that need working software, not slide decks.',
  },
  {
    question: 'How is DataBackfill different from a typical AI consulting firm?',
    answer:
      'Every engagement is staffed by senior operators who have shipped this kind of work before, not junior consultants learning on your dime. We ship into production. We don’t hand off a roadmap and disappear.',
  },
  {
    question: 'Can DataBackfill integrate Claude or other LLMs into our existing product?',
    answer:
      'Yes. We design and deploy production Claude implementations integrated with your existing stack, including prompt engineering, evals, guardrails, and tool use for agentic workflows.',
  },
  {
    question: 'Does DataBackfill build RAG systems for proprietary data?',
    answer:
      'Yes. We build custom retrieval pipelines over proprietary data sources, including vector databases, embedding pipelines, hybrid search, and document ingestion, so your AI answers accurately instead of hallucinating.',
  },
  {
    question: 'Do you still build GA4 to BigQuery pipelines?',
    answer:
      'Yes. DataBackfill Sync, our productized GA4-to-BigQuery backfill tool, has powered over 1,400 successful syncs with 99.9% production uptime across hundreds of properties.',
  },
  {
    question: 'How long does a typical engagement take, and what does it cost?',
    answer:
      'Most engagements run 6–12 weeks and are priced on scope, not seats. A 2-week Discovery Sprint is available first if you need a technical plan and estimate before committing to a full build.',
  },
  {
    question: 'Does DataBackfill work with early-stage startups, or only larger companies?',
    answer:
      'Both. We’ve shipped production systems for early-stage startups (including an iOS health app and an investing platform) as well as ongoing SaaS infrastructure work.',
  },
];

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/meewwwbb';

const ContactPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  const [formData, setFormData] = useState({ name: '', email: '', company: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus('success');
        trackServiceInquiry('contact');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-root">
      <style>{css}</style>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;1,6..72,400&family=Inter:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />

      <header>
        <nav>
          <Link to="/" className="logo">Data<span>Backfill</span></Link>
          <button
            className="nav-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span></span><span></span><span></span>
          </button>
          <div className="nav-actions">
            <Link to="/auth" className="nav-login">Log in</Link>
            <Link to="/contact" className="nav-cta">Start a Project</Link>
          </div>
          <div className={`nav-links${menuOpen ? ' open' : ''}`}>
            <Link to="/#services" onClick={closeMenu}>Services</Link>
            <Link to="/#work" onClick={closeMenu}>Case Studies</Link>
            <Link to="/#process" onClick={closeMenu}>How we work</Link>
            <Link to="/#team" onClick={closeMenu}>Team</Link>
            <Link to="/#pricing" onClick={closeMenu}>Pricing</Link>
          </div>
        </nav>
      </header>

      <section className="hero">
        <div className="wrap">
          <div className="eyebrow">Let's connect</div>
          <h1>Get in touch with <em>our team</em></h1>
          <p>Tell us what you're trying to build: an AI agent, a RAG system, a data pipeline, or something in between. We respond to every inquiry within 24 hours.</p>
        </div>
      </section>

      <section className="section">
        <div className="wrap contact-grid">
          <div>
            <div className="info-label">Contact information</div>
            <div className="info-list">
              <div className="info-row">
                <div className="num serif">01</div>
                <div>
                  <h3>Company Information</h3>
                  <p>DataBackfill LLC</p>
                  <p>California, United States</p>
                </div>
              </div>
              <div className="info-row">
                <div className="num serif">02</div>
                <div>
                  <h3>Email Us</h3>
                  <p><a href="mailto:support@databackfill.com">support@databackfill.com</a></p>
                </div>
              </div>
              <div className="info-row">
                <div className="num serif">03</div>
                <div>
                  <h3>Business Hours</h3>
                  <p>We follow the sun</p>
                </div>
              </div>
              <div className="info-row">
                <div className="num serif">04</div>
                <div>
                  <h3>Slack</h3>
                  <p>
                    <a
                      href="https://backfillingcrew.slack.com/archives/C0814RCS3LH"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Find us on Slack
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="form-card">
            {status === 'success' ? (
              <div className="success-card">
                <div className="success-icon">✓</div>
                <h2>Thanks for reaching out!</h2>
                <p>We got your message and will respond within 24 hours.</p>
              </div>
            ) : (
              <>
                <h2>Send us a message</h2>
                <form onSubmit={handleSubmit}>
                  <div className="field">
                    <label>Full Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                  </div>
                  <div className="field">
                    <label>Email Address</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="field">
                    <label>Company (Optional)</label>
                    <input type="text" name="company" value={formData.company} onChange={handleChange} />
                  </div>
                  <div className="field">
                    <label>Message</label>
                    <textarea name="message" rows={4} value={formData.message} onChange={handleChange} required />
                  </div>
                  {status === 'error' && (
                    <p style={{ color: '#c0392b', fontSize: 14, marginBottom: 16 }}>
                      Something went wrong. Please try again or email us at{' '}
                      <a href="mailto:support@databackfill.com" style={{ color: '#c0392b', fontWeight: 600 }}>
                        support@databackfill.com
                      </a>.
                    </p>
                  )}
                  <button type="submit" className="submit-btn" disabled={status === 'submitting'}>
                    {status === 'submitting' ? 'Sending…' : 'Send Message →'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>

      <section className="section faq-section" style={{ borderBottom: 'none' }}>
        <div className="wrap">
          <div className="section-head">
            <div className="section-num">FAQ</div>
            <h2>Frequently asked questions</h2>
            <p className="sub">Can't find what you're looking for? Reach out to our team.</p>
          </div>
          <div className="faq-list">
            {faqs.map((faq) => (
              <div className="faq-item" key={faq.question}>
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer>
        <div className="wrap foot-cols">
          <div className="foot-brand">
            <div className="logo">Data<span>Backfill</span></div>
            <p>A boutique AI & data delivery studio: senior engineers, architects, and product designers shipping production systems.</p>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Services</div>
            <Link to="/#services">Claude Implementation</Link>
            <Link to="/#services">RAG & Knowledge Systems</Link>
            <Link to="/#services">Agentic Workflows</Link>
            <Link to="/#services">Data Infrastructure</Link>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Company</div>
            <Link to="/#work">Case Studies</Link>
            <Link to="/#team">Team</Link>
            <Link to="/#pricing">Pricing</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Use Cases</div>
            <Link to="/use-cases/cmo">25 Use Cases for CMOs</Link>
            <Link to="/use-cases/marketing-ai">25 Marketing AI Use Cases</Link>
            <Link to="/use-cases/ai-bdr">25 AI BDR Use Cases</Link>
            <Link to="/use-cases/cfo">15 Use Cases for CFOs</Link>
            <Link to="/use-cases/customer-support">20 AI Customer Support Use Cases</Link>
            <Link to="/use-cases/revops">12 RevOps AI Use Cases</Link>
            <Link to="/use-cases/hr">10 AI Use Cases for HR Teams</Link>
            <Link to="/use-cases/data-teams">18 Use Cases for Data Teams</Link>
          </div>
        </div>
        <div className="wrap foot-bottom">
          <div>© 2026 DataBackfill. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
